import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import Routes from './Routes';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';
import './i18n';

function App() {
  return (
    <Provider store={store}>
      <FeatureFlagsProvider>
        <Routes />
      </FeatureFlagsProvider>
    </Provider>
  );
}

export default App;